module.exports = __webpack_public_path__ + "img/bocceWhite.27fc3cf4.svg";